import React from 'react';
import { apiEndpoint } from "helpers/url_helper";

import MetaTags from 'react-meta-tags';
// import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react"

import Switch from "react-switch"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  FormGroup,
  Form,
  Button,
  UncontrolledTooltip,
  CardSubtitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  CardImg,


} from "reactstrap"
//import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
//import ReactPDF from '@react-pdf/renderer';
import ReactDOM from 'react-dom';
import jsPDF from 'jspdf';
import { connect } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert";
import { AvForm, AvField } from "availity-reactstrap-validation";


//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import { useEffect } from 'react';
import { useState, createContext } from 'react';
import img2 from "../../assets/images/Ador_logo_cropped.png"
import violationImage from "../../assets/images/violationImage.png"
import challanpreview from "../../assets/images/challanpreview.jpg"
import { constrainPoint } from '@fullcalendar/react';
import ZoneConfigImage from "../../assets/images/ZoneConfigImage.jpg"






//export const LatLongContext = createContext("67");


function AddChallanConfigDetails(props) {
  const breadcrumbItems = [
    { title: "Settings", link: "#" },
    { title: "Challan", link: "/ChallanSettings" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Challan', breadcrumbItems);
  })
  var EncodedLogo = '';
  var CompanyLogoPath = '';

  const [SelectedCampusValue, setSelectedCampusValue] = useState(1);
  const [CampsuList, setCampusList] = useState([]);
  const [modal_small, setmodal_small] = useState(false);

  const [CompanyName, setCompanyName] = useState();
  const [CompanyAddress1, setNewCompanyAddress1] = useState();
  const [CompanyAddress2, setNewCompanyAddress2] = useState();
  const [CityName, setCityName] = useState();
  const [StateName, setStateName] = useState();
  const [NewChallanAmount, setNewChallanAmount] = useState();
  const [ChallanDetailsResponse, setChallanDetailsResponse] = useState();
  const [basic, setbasic] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [Base64CompanyLogo, setBase64CompanyLogo] = useState();
  const [showChallanPreview, setShowChallanPreview] = useState(false);
  const [ ValidateCompanyLogo, setValidateCompanyLogo] = useState(false);
  const [showZoneConfigImage, setShowZoneConfigImage] = useState(false);
  const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });
  const [startCoordinates, setStartCoordinates] = useState(null);
  const [textBoxValue, setTextBoxValue] = useState('');
  const [polyCoordinates, setPolyCoordinates] = useState([]);
  const [points, setPoints] =useState('');
  const [circleCoordinates, setCircleCoordinates] = useState([]);
  const [DuplicateChallan, setDuplicateChallan] = useState(false);

  const Offsymbol = (props) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        No
      </div>
    )
  }
  
  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Yes
      </div>
    )
      }


  const PolyCoordinates = [
    { x: 100, y: 10 },
    { x: 170, y: 100 },
    { x: 40, y: 90 },
  {x:190, y:56}
  ];

  





  const [AddNewCampusValue, setAddNewCampusValue] = useState();

  const [DataValues, setDataValues] = useState({ NewLatitudeValue: 18.5204, NewLongitudeValue: 73.2341 });


  //const LatContextValue = {NewLatitudeValue, setNewLatitudeValue}; 



  // const styles = StyleSheet.create({
  //   page: {
  //     flexDirection: 'row',
  //     backgroundColor: '#E4E4E4'
  //   },
  //   section: {
  //     margin: 10,
  //     padding: 10,
  //     flexGrow: 1
  //   }
  // });

   const myDownload = () => {
    debugger;
    var doc = new jsPDF('p', 'mm','a4');
    

    var img = new Image();
    img.src = "data:image/jpg;base64" +Base64CompanyLogo;
    console.log("Image source--->"+img.src);
    console.log(doc.getFontList());
     const CompanyAddress = CompanyAddress1+","+CompanyAddress2;
     const CityAddress = CityName+","+StateName;
     doc.addFont('courier', 'Bold');
     doc.setFontSize(25);
     doc.text( "Challan Ticket",100,10,"center");
     doc.setFontSize(20);
     doc.text('Ador Powertron Ltd', 140, 30, 'right');
     doc.setFontSize(12); 
     doc.text(CompanyAddress, 140, 35, 'right');
     doc.setFontSize(12); 
     doc.text(CityAddress, 140, 40, 'right');

     
      doc.rect(15, 60, 180, 60);
      doc.setFontSize(12);
      doc.text(17, 67, "Challan ID");
      doc.text(17, 77, "Violation Date Time");
      doc.text(17, 87, "Violation Speed");
      doc.text(17, 97, "Vehicle Owner");
      doc.text(17, 107, "Regitration Number");
      doc.text(17, 117,"Challan Type");
      doc.text(17, 127, "Challan Amount");
      doc.addImage(img, 'png', 150, 20, 50, 30);
                    //  doc.rect(15, 63, 180, 75);
                  doc.line(100,60,100,120)
                   doc.line(15, 70, 195, 70);
                   doc.line(15, 80, 195, 80);
                   doc.line(15, 90, 195, 90);
                   doc.line(15, 100, 195, 100);
                   doc.line(15, 110, 195, 110);
                   doc.line(15,120,195,120)
                  //  doc.line(15, 120, 195, 120);
       
                  
      doc.rect(15, 130, 180, 100);  
      doc.addImage(img, 'png', 17, 132, 175, 98)          
                  
      
      doc.save('demo.pdf')

   }

  const handleInput = (e) => {
    const { LocationName, value } = e.target;

    setFormValues({ ...FormValues, [LocationName]: value });
    console.log(FormValues);
  }
  function ValidateCompanyLog(value) {
    debugger;
    const allowedTypes = ['jpeg', 'png','jpg', 'JPEG', 'PNG', 'JPG'];
    if(value != "")
    {
    
      const fileExtension = value.split('.').pop();
    
      if (!allowedTypes.includes(fileExtension)) {
        // Invalid file type
        // Set an error message or take appropriate action
        return "Please choose Image File";
      } else {
        return true;
      }
    }
   }
   
   

  const SelectCompanyLogo = (e) => {
    debugger;
    const allowedTypes = ['jpeg', 'png','jpg', 'JPEG', 'PNG', 'JPG'];
    let fileType = e.target.files[0].name.split('.');
    if(allowedTypes.includes(fileType[1]))
      {
    let files = e.target.files;
    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (e) => {
      console.log('image data: ', e.target.result);
      EncodedLogo = e.target.result;

    }
    };
   // setValidateCompanyLogo(false);
  // 

  //   let files = e.target.files;
  //  let fileType = e.target.files[0].name.split('.');
  //  if(allowedTypes.includes(fileType[1]))
  //  {
  //   let reader = new FileReader();
  //   reader.readAsDataURL(files[0]);
  //   reader.onload = (e) => {
  //    console.log('image data: ', e.target.result);
  //     EncodedLogo = e.target.result;

  //   };
  //   console.log(EncodedLogo);

  //   CompanyLogoPath = e.target.value;
  //   GetChallanDetails(SelectedCampusValue);
  //   return true; 
  //  }
  //  else{
  //   //setChallanDetailsResponse('Please Add Image File');
  //  // setbasic(true);
  //   //setValidateCompanyLogo(false);
  //   return "Invalid File Type"
  //  }
  


  }

  const tog_small = () => {
    debugger;
    setmodal_small(!modal_small)
    document.body.classList.add("no_padding")
  }

  useEffect(() => {
    debugger;
    // UserValidated
    fetch(apiEndpoint+"/CampusList",
      {
        method:"POST",

        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then((data) => {
        debugger;
        setCampusList(data.CampusList);
        GetChallanDetails(data.CampusList[0].CampusID);
        //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))

      });

  }, []);

  const handleCampusChange = event => {
    debugger;


    setSelectedCampusValue(event.target.value);
    GetChallanDetails(event.target.value);
    



  };


  const GetChallanDetails = (CampusID) => {
    setShowChallanPreview(false);
    setCompanyName('');
          setNewCompanyAddress1('');
          setNewCompanyAddress2('');
          setCityName('');
          setStateName('');
          setNewChallanAmount('');
          setBase64CompanyLogo('');
          EncodedLogo = '';

    debugger;
setSelectedCampusValue(CampusID);
    var intCampusID = CampusID;
    // UserValidated
    fetch(apiEndpoint+"/GetChallanConfigDetails",
      {
       method:"POST",
        headers: {
          'Content-Type': 'application/json',
          // 'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })

      .then(res => res.json())
      .then((data) => {
        debugger;
        if(data.base64Image != null)
          {
            setBase64CompanyLogo(data.base64Image);
          }

        if (data.ChallanConfigDetails != null) {
          if(data.ChallanConfigDetails.CompanyName != null && data.ChallanConfigDetails.CompanyName != "")
          {
            setShowChallanPreview(true);
          }
          else{
            setShowChallanPreview(false);
          }
          console.log("data---->", data);
          setCompanyName(data.ChallanConfigDetails.CompanyName);
          setNewCompanyAddress1(data.ChallanConfigDetails.AddressLine1);
          setNewCompanyAddress2(data.ChallanConfigDetails.AddressLine2);
          setCityName(data.ChallanConfigDetails.City);
          setStateName(data.ChallanConfigDetails.State);
          setNewChallanAmount(data.ChallanConfigDetails.ChallanAmount);
          setDuplicateChallan(data.ChallanConfigDetails.DuplicateChallan);
       }
        else {
          setShowChallanPreview(false);
          setCompanyName('');
          setNewCompanyAddress1('');
          setNewCompanyAddress2('');
          setCityName('');
          setStateName('');
          setNewChallanAmount('');

        }

      });

  };



  const SubmitChallanDetails = () => {
    debugger;
    if(EncodedLogo == null || EncodedLogo == "")
    {
      EncodedLogo = Base64CompanyLogo;
    }
    // UserValidated
    fetch(apiEndpoint+'/AddNewChallanConfig',
      {
        mode: "cors",
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          //'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({
          
          "intCampusID": SelectedCampusValue,
          "intChallanAmount": NewChallanAmount,
          "strCompanyName": CompanyName,
          "strAddressLine1": CompanyAddress1,
          "strAddressLine2": CompanyAddress2,
          "strCity": CityName,
          "strState": StateName,
          "strBase64LogoImage": EncodedLogo,
          "boolDuplicateChallan": DuplicateChallan,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })


      }
    )
      .then(res => res.json())
      .then((data) => {
        
        if (data.ResponseType == "success") {
          debugger;
          setChallanDetailsResponse(data.ResponseMessage);        
          setbasic(true);
          setModalOpen(false);

        }
        else if (data.ResponseType == "error") {
          setChallanDetailsResponse(data.ResponseMessage);  
          setbasic(true);

        }
      });

  }

  const handlCoordinatesClick = (event) => {
    
    if  (polyCoordinates.length >= 5) {
      setPoints(' ');
      setPolyCoordinates([]);
      setTextBoxValue(' ');
      setCircleCoordinates([]);
      return; 
    }
    debugger;
    const rect = event.target.getBoundingClientRect();
    const x = (event.clientX - rect.left);
    const y = (event.clientY - rect.top);
   let newCoordinates = [...polyCoordinates, { x: x, y: y }];
    setPolyCoordinates(newCoordinates);
    if (newCoordinates.length > 5) {
      newCoordinates = newCoordinates.slice(newCoordinates.length - 5); // Keep the last 5 coordinates
    }
    const pointString = newCoordinates.map(coord => `${coord.x},${coord.y}`).join(' ');
    //setTextBoxValue(`X: ${x*2}, Y: ${y*2}`);
    setTextBoxValue(pointString);

    setPoints(pointString);
    const newCircleCoordinates = [...circleCoordinates, { x, y }];
    setCircleCoordinates(newCircleCoordinates);
   };

   

   const handleTextBoxChange = (event) => {
    setTextBoxValue(event.target.value);
  };




  return (
    <React.Fragment>
      <MetaTags>
        <title>Indus | Challan Settings</title>
      </MetaTags>
      <Row className="col-md-12">

        <Col className="col-md-12">
          <Card>
            <CardBody>
              {basic ? (
                <SweetAlert
                  title={ChallanDetailsResponse}

                  onConfirm={() => {
                    debugger;
                    setbasic(false)
                  }}
                />
              ) : null}





              {modalOpen ?
                <Modal
                  isOpen={modal_small}
                  

                  toggle={() => {
                    tog_small()

                  }}
                  size="lg"
                  

                >
                  <ModalHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                    <h3>Challan Ticket</h3>




                  </ModalHeader>
                  <ModalBody>
                    <Row>
                      <div class="col-sm-8">

                        <div class="col-sm-12" style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                        }}>
                          <h3>{CompanyName}</h3>
                        </div>
                        <div class="col-sm-12" style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                        }}>
                          <h6>{CompanyAddress1}, {CompanyAddress2}</h6>
                        </div>

                        <div class="col-sm-12" style={{
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                        }}>
                          <h6>{CityName}, {StateName}</h6>
                        </div>
                      </div>

                      <div class="col-sm-4">
                        <div class="col-sm-2">
                          <img
                            className="rounded me-4"
                            alt="Lexa"
                            width="200"
                            
                            src={"data:image/jpeg;base64,"+Base64CompanyLogo}
                          />
                        </div>
                      </div>
                    </Row>








                    <br />
                    <Col className="col-md-12">
                      <Card>
                        <CardBody>


                          <div className="table-responsive">
                            <table className="table table-bordered table-striped table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th className="col-sm-6 text-nowrap" scope="row">Challan ID</th>
                                  <td colSpan="12">23</td>
                                </tr>
                                <tr>
                                  <th className="col-sm-6 text-nowrap" scope="row">Violation Date Time</th>
                                  <td colSpan="12">2023-17-03 10:08:23</td>
                                </tr>
                                <tr>
                                  <th className="col-sm-6 text-nowrap" scope="row">Violation Speed</th>
                                  <td colSpan="12"> 21Km/Hr</td>
                                </tr>
                                <tr>
                                  <th className="col-sm-6 text-nowrap" scope="row">Registration Number</th>
                                  <td colSpan="12"> MH46BQ0269</td>
                                </tr>
                                <tr>
                                  <th className="col-sm-6 text-nowrap" scope="row">Challan Type</th>
                                  <td colSpan="12"> Penalty</td>
                                </tr>
                                <tr>
                                  <th className="col-sm-6 text-nowrap" scope="row">Challan Amount</th>
                                  <td colSpan="12"> {NewChallanAmount}</td>
                                </tr>
                              </thead>
                            </table>
                          </div>


                        </CardBody>
                      </Card>
                    </Col>
                    <div class="col-sm-12" style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}>
                      <CardImg className="img-fluid" style={{ width: "600px", height: "400px" }} src={challanpreview} alt="Lexa" />
                    </div>







                  </ModalBody>
                  <ModalFooter>
                    {/* <div className="nav">
                      <button type="submit" onClick={myDownload} className="btn btn-primary w-md">Download</button>
                    </div> */}

                  </ModalFooter>

                </Modal>


                : ""}


               



              <Row className="mb-2">
                <label
                  htmlFor="example-text-input"
                  className="col-md-2 col-form-label"
                >
                  Campus
                </label>

                <div className="col-md-4">
                  <select className="form-control" value={SelectedCampusValue} onChange={handleCampusChange} classNamePrefix="select2-selection"
                  >
                    {CampsuList.map(i => <option value={i.CampusID}>{i.CampusName}</option>
                    )}



                  </select>
                </div>


              </Row>
              <AvForm onValidSubmit={SubmitChallanDetails}> 
              <Row>

                <div className="col-md-6">

                  <Row className="mb-2">
                    <label
                      htmlFor="example-search-input"
                      className="col-md-4 col-form-label"
                    >
                      Challan Amount
                    </label>
                    <div className="col-md-8">
                      <AvField
                        className="form-control"
                        type="text"
                        name = "Challan Amount"
                        errorMessage="This text field is required"
                          validate={{
                            required: { value: true },
                            pattern: { value: "/^[0-9]+$/", errorMessage: "Only Numeric Values Please ! " },
                            
                          }}
                        value={NewChallanAmount}        
                        onChange={(event) => {
                          setNewChallanAmount(event.target.value);
                        }}
                      />
                    </div>
                  </Row>
                  <Row className="mb-2">
                    <label
                      htmlFor="example-search-input"
                      className="col-md-4 col-form-label"
                    >
                      DuplicateChallan
                    </label>
                    <div className="col-md-8">
                   
           <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  onChange={() => {
                    setDuplicateChallan(!DuplicateChallan)
                  }}
                  checked={DuplicateChallan}
                />
           </div>
                  </Row>

                  <Row className="mb-2">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-4 col-form-label"
                    >
                      Company Logo
                    </label>

                    <div className="col-md-8">
                      
                      <AvField type="file"
                        className="form-control form-control-file "
                        data-buttonname="btn-secondary"
                        name = "Company Logo"
                        errorMessage = "Please Add Valid File"
                        validate = {{ValidateCompanyLog}}
                        onChange={SelectCompanyLogo}

                      />
                    </div>

                  </Row>

                  <Row className="mb-2">
                    <label
                      htmlFor="example-search-input"
                      className="col-md-4 col-form-label"
                    >
                      Company Name
                    </label>
                    <div className="col-md-8">
                      <AvField
                        className="form-control"
                        type="text"
                        name = "Company Name"
                        validate={{
                          required: { value: true },
                          pattern: { value: "/^[A-Za-z ]+$/", errorMessage: "Only Numeric Values Please ! " },
                          
                        }}
                        value={CompanyName}
                        onChange={(event) => {
                          setCompanyName(event.target.value);
                        }}
                      />
                    </div>
                  </Row>
                  <Row className="mb-1">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-4 col-form-label"
                    >
                      Company Address
                    </label>
                  </Row>
                  <Row className="mb-1 offset-2">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      Line 1
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={CompanyAddress1}
                        onChange={(event) => {
                          setNewCompanyAddress1(event.target.value);
                        }}

                      />
                    </div>
                  </Row>





                  <Row className="mb-1 offset-2">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      Line 2
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={CompanyAddress2}
                        onChange={(event) => {
                          setNewCompanyAddress2(event.target.value);
                        }}
                      />
                    </div>
                  </Row>

                  <Row className="mb-1 offset-2">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      City
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={CityName}
                        onChange={(event) => {
                          setCityName(event.target.value);
                        }}
                      />
                    </div>
                  </Row>

                  <Row className="mb-3 offset-2">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      State
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="text"
                        defaultValue={StateName}
                        onChange={(event) => {
                          setStateName(event.target.value);
                        }}
                      />
                    </div>
                  </Row>

              
                </div>


              </Row>


              <div className="lg -6 offset-2">
                <button type="submit" className="btn btn-primary w-md">Submit</button>{" "}
{showChallanPreview &&
  <button type="button" className="btn btn-primary w-md" onClick={() => {
                  tog_small();
                  GetChallanDetails(SelectedCampusValue);
                  setModalOpen(true);
                }}> Challan Preview</button> }
                
<br/>

              </div>
            
              </AvForm>








            </CardBody>
          </Card>
        </Col>
      </Row>





    </React.Fragment>



  )

}

//export default AddChallanConfigDetails;
export default connect(null, { setBreadcrumbItems })(AddChallanConfigDetails);